// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatMessageBubble .ChatMessageBubble-Content {
  min-width: 0;
  max-width: 100%;
  flex-shrink: 1;
}
.ChatMessageBubble .ChatMessageBubble-Message {
  width: fit-content;
  max-width: 100%;
  padding: 1rem;
  border-radius: var(--bs-border-radius);
  white-space: pre-line;
  overflow-wrap: break-word;
}
.ChatMessageBubble.outgoing .ChatMessageBubble-Message {
  background-color: var(--bs-secondary-subtle);
  color: var(--bs-dark);
}
.ChatMessageBubble.incoming .ChatMessageBubble-Message {
  background-color: var(--bs-primary);
  color: var(--bs-light);
}

.ChatMessageBubble-Stats {
  font-size: 0.9rem;
  color: var(--bs-gray);
}`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/ChatMessage/ChatMessageBubble/styles.scss"],"names":[],"mappings":"AACE;EACE,YAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAEE;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sCAAA;EACA,qBAAA;EACA,yBAAA;AAAJ;AAGI;EACE,4CAAA;EACA,qBAAA;AADN;AAKI;EACE,mCAAA;EACA,sBAAA;AAHN;;AAQA;EACE,iBAAA;EACA,qBAAA;AALF","sourcesContent":[".ChatMessageBubble {\n  .ChatMessageBubble-Content {\n    min-width: 0;\n    max-width: 100%;\n    flex-shrink: 1;\n  }\n  .ChatMessageBubble-Message {\n    width: fit-content;\n    max-width: 100%;\n    padding: 1rem;\n    border-radius: var(--bs-border-radius);\n    white-space: pre-line;\n    overflow-wrap: break-word;\n  }\n  &.outgoing {\n    .ChatMessageBubble-Message {\n      background-color: var(--bs-secondary-subtle);\n      color: var(--bs-dark);\n    }\n  }\n  &.incoming {\n    .ChatMessageBubble-Message {\n      background-color: var(--bs-primary);\n      color: var(--bs-light);\n    }\n  }\n}\n\n.ChatMessageBubble-Stats {\n  font-size: 0.9rem;\n  color: var(--bs-gray);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
